import React, {Component} from "react";
import LoggedOutLayout from "features/layouts/pages/logged-out/index";
import Modal from "features/components/modal";
import Title from "features/components/title";
import Button from "features/components/button";
import {historyObject} from "historyObject";
import Text from "features/components/text";
import {__} from "services/i18n";
import "./index.scss";

export class FourOFour extends Component {

    render() {
        return (
            <LoggedOutLayout type={"dark"} className={"four-o-four"}>
                <Modal>
                    <Title size={34} align={"center"}>{__("404.title")}</Title>
                    <Text size={16} align={"center"}>{__("404.text")}</Text>
                    <Button title={__("buttons.back-home")}
                            onClick={() => historyObject.push("/")}
                            type={"accent"}
                            icon={"arrow-right"} />
                </Modal>
            </LoggedOutLayout>
        )
    }
}
